var exports = {
  "pq": "UserIdentityRow.module__info___MVlvTV",
  "UU": "UserIdentityRow.module__name___MVlvTV",
  "Tc": "UserIdentityRow.module__tag___MVlvTV",
};

module.exports = exports;
